"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (application, dataLayerData) => {
    return {
        env: dataLayerData.environment,
        name: application,
        version: '1',
    };
};
//# sourceMappingURL=create.app.data.js.map